import React, { useState, useEffect } from 'react';
import { WebviewHttpHandler } from 'shared/webviewHttpHandler';
import {
  Button,
  Modal,
  Tabs,
  SpinLoading,
  AutoCenter,
  ErrorBlock,
  Image,
  ImageViewer,
} from 'antd-mobile';
import { FileTextOutlined } from '@ant-design/icons';

const PaymentDetails = ({ polno, photoaddr }) => {
  const httpHandler = new WebviewHttpHandler(true);

  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isImgViwerVisible, setIsImgViwerVisible] = useState(false);
  const [polphoto, setPolphoto] = useState(null);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const showImgViwer = () => {
    setIsImgViwerVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const getPaymentImage = () => {
    setIsLoading(true);
    httpHandler
      .post('/service/member/polphoto', {
        polno: polno,
        photoaddr: photoaddr,
      })
      .then((response) => {
        if (response.success) {
          setPolphoto(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setPolphoto(null);
    if (isModalVisible) {
      getPaymentImage();
    }
  }, [isModalVisible]);

  return (
    <>
      <Button onClick={showModal} block className="light-button">
        圖檔預覽 <FileTextOutlined style={{ fontSize: '18px' }} />
      </Button>
      <Modal
        showCloseButton={true}
        visible={isModalVisible}
        onClose={handleOk}
        closeOnMaskClick={true}
        content={
          <div>
            {isLoading ? (
              <AutoCenter className="mt-8">
                <SpinLoading />
              </AutoCenter>
            ) : !polphoto ? (
              <ErrorBlock
                status="empty"
                title={<>沒有罰單明細</>}
                description={<></>}
              />
            ) : (
              <Image
                src={`data:image/jpeg;base64,${polphoto}`}
                onClick={showImgViwer}
              />
            )}
          </div>
        }></Modal>
      <ImageViewer
        image={`data:image/jpeg;base64,${polphoto}`}
        visible={isImgViwerVisible}
        onClose={() => {
          setIsImgViwerVisible(false);
        }}
      />
    </>
  );
};

export default PaymentDetails;
